import { sourcesApiSlice } from "api/sourcesApi.slice";
import { StyledModalText, UIButton } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { useTranslate } from "common/utilities/useTranslate";
import { deactivateModal } from "domains/modal/actions";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { getModalParams } from "domains/modal/selectors";
import type { ModalParams } from "domains/modal/types";

export const ConfirmDeleteSourceModal = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const go = useGo();

  const { sourceId } = useSelector(getModalParams) as ModalParams<"ConfirmDeleteSource">;

  const [deleteSource, { isLoading }] = sourcesApiSlice.endpoints.deleteSource.useMutation();

  const handleYes = async () => {
    await deleteSource({ sourceId });
    dispatch(deactivateModal());
    go("/moderate/sources");
  };

  return (
    <>
      <ModalHeader title={translate("app.moderate.sources.delete.modal.title")} />
      <StyledModalText>{translate("app.moderate.sources.delete.title")}</StyledModalText>
      <UIButton
        data-test-id="confirm-deleting-custom-map-button"
        error
        fullwidth
        onClick={handleYes}
        isLoading={isLoading}
      >
        {translate("app.create.delete.confirm")}
      </UIButton>
    </>
  );
};
